<template>
  <div class="settings-panel__container" v-if="internalValue">
    <!-- Position -->
    <div class="setting-section">
      <p class="setting-section__h">Позиция</p>
      <div class="setting-row">
        <label>Тип</label>
        <p><u>{{ fontTypeLabel }}</u></p>
      </div>
      <div class="setting-row">
        <label>ID</label>
        <p class="setting-row__p"><u>{{ internalValue.id }}</u></p>
        <button @click="copyId(internalValue.id)" class="modal-copy__button">
          <Icon svgClass="modal-copy__svg" name="copy" size="16" />
        </button>
      </div>
      <div class="setting-row">
        <button @click="deleteElement()" class="modal-delete__button">
          <Icon svgClass="modal-copy__svg" name="close" size="16" />
          Удалить
        </button>
      </div>
    </div>

    <!-- Spacing -->
    <div class="setting-section">
      <p class="setting-section__h">Отступы</p>
      <div class="setting-row">
        <label class="label-row">Внутренний</label>
        <div class="setting-column">
          <InputComponent
            v-for="(pad, idx) in iternalPadding"
            :key="'pad-'+idx"
            type="number"
            :model-value="iternalPadding[idx]"
            @update:model-value="val => updatePadding(val, idx)"
            suffix="rem"
            :min="0"
            :step="1"
            :max="150"
          />
        </div>
      </div>

      <div class="setting-row">
        <label class="label-row">Внешний</label>
        <div class="setting-column">
          <InputComponent
            v-for="(marg, idx) in iternalMargin"
            :key="'mar-'+idx"
            type="text"
            :model-value="iternalMargin[idx]"
            @update:model-value="val => updateMargin(val, idx)"
            suffix="rem"
            :step="1"
            :max="150"
          />
        </div>
      </div>
    </div>

    <!-- Sizes -->
    <div class="setting-section">
      <p class="setting-section__h">Размеры</p>
      <div class="setting-row">
        <label class="label-row">Ширина</label>
        <InputComponent
          type="text"
          :model-value="responsiveSettings.width ?? defaultResponsive('width')"
          @update:model-value="val => updateResponsiveOrSetting('width', val)"
          suffix="rem"
          :min="0"
          :step="1"
          :max="150"
        />
      </div>

      <div class="setting-row">
        <label class="label-row">Высота</label>
        <InputComponent
          type="text"
          :model-value="responsiveSettings.height ?? defaultResponsive('height')"
          @update:model-value="val => updateResponsiveOrSetting('height', val)"
          suffix="rem"
          :min="0"
          :step="1"
          :max="150"
        />
      </div>

      <div class="setting-row">
        <label class="label-row">Минимальная ширина</label>
        <InputComponent
          type="text"
          :model-value="responsiveSettings.minWidth ?? defaultResponsive('minWidth')"
          @update:model-value="val => updateResponsiveOrSetting('minWidth', val)"
          suffix="rem"
          :min="0"
          :step="1"
          :max="150"
        />
      </div>

      <div class="setting-row">
        <label class="label-row">Минимальная высота</label>
        <InputComponent
          type="text"
          :model-value="responsiveSettings.minHeight ?? defaultResponsive('minHeight')"
          @update:model-value="val => updateResponsiveOrSetting('minHeight', val)"
          suffix="rem"
          :min="0"
          :step="1"
          :max="150"
        />
      </div>

      <div class="setting-row">
        <label class="label-row">Максимальная ширина</label>
        <InputComponent
          type="text"
          :model-value="responsiveSettings.maxWidth ?? defaultResponsive('maxWidth')"
          @update:model-value="val => updateResponsiveOrSetting('maxWidth', val)"
          suffix="rem"
          :min="0"
          :step="1"
          :max="150"
        />
      </div>

      <div class="setting-row">
        <label class="label-row">Максимальная высота</label>
        <InputComponent
          type="text"
          :model-value="responsiveSettings.maxHeight ?? defaultResponsive('maxHeight')"
          @update:model-value="val => updateResponsiveOrSetting('maxHeight', val)"
          suffix="rem"
          :min="0"
          :step="1"
          :max="150"
        />
      </div>
    </div>

    <!-- Colors -->
    <div class="setting-section">
      <p class="setting-section__h">Цвет</p>
      <div class="setting-row">
        <label>Фон</label>
        <ColorPicker
          :model-value="internalValue.settings?.backgroundColor"
          @update:model-value="val => updateSetting('backgroundColor', val)"
        />
      </div>
      <div class="setting-row">
        <label>Текст</label>
        <ColorPicker
          :model-value="internalValue.settings?.color"
          @update:model-value="val => updateSetting('color', val)"
        />
      </div>
    </div>

    <!-- Group settings -->
    <div class="setting-section">
      <p class="setting-section__h">Настройки группы</p>

      <div class="setting-row">
        <label class="label-row">Направление</label>
        <Multiselect
          :options="flexDirectionOptions"
          placeholder="Направление"
          :model-value="responsiveSettings.flexDirection ?? internalValue.settings?.flexDirection"
          @update:model-value="val => updateResponsiveOrSetting('flexDirection', val)"
        />
      </div>

      <div class="setting-row">
        <label class="label-row">По горизонтали</label>
        <Multiselect
          :options="justifyContentOptions"
          placeholder="Выравнивание"
          :model-value="responsiveSettings.justifyContent ?? internalValue.settings?.justifyContent"
          @update:model-value="val => updateResponsiveOrSetting('justifyContent', val)"
        />
      </div>

      <div class="setting-row">
        <label class="label-row">По вертикали</label>
        <Multiselect
          :options="alignItemsOptions"
          placeholder="Выравнивание"
          :model-value="responsiveSettings.alignItems ?? internalValue.settings?.alignItems"
          @update:model-value="val => updateResponsiveOrSetting('alignItems', val)"
        />
      </div>

      <div class="setting-row">
        <label class="label-row">Перенос</label>
        <Multiselect
          :options="flexWrapOptions"
          placeholder="Перенос"
          :model-value="responsiveSettings.flexWrap ?? internalValue.settings?.flexWrap"
          @update:model-value="val => updateResponsiveOrSetting('flexWrap', val)"
        />
      </div>
    </div>

  </div>
</template>

<script>
import InputComponent from '@/components/UI/Input/Input.vue';
import TextareaComponent from '@/components/UI/Input/Textarea.vue';
import ColorPicker from '@/components/UI/ColorPicker/index.vue';
import Multiselect from '@/components/UI/Select/Multiselect.vue';
import Icon from '@/components/UI/Icon/Icon.vue';
import { screenSizes } from '@/config/screen-sizes.js';
import { mapGetters } from 'vuex';
import { safeClone } from '@/utils/clone.js';
import {
  idGenerator,
  normalizeSpacingVal,
  buildSpacingString
} from '@/utils/blocks/block-settings-utils.js';
import {
  flexDirectionOptions,
  justifyContentOptions,
  alignItemsOptions,
  flexWrapOptions
} from '@/config/flex-options.js';

export default {
  name: 'DivSettings',
  components: { InputComponent, TextareaComponent, ColorPicker, Multiselect, Icon },
  props: {
    internalValue: { type: Object, required: true }
  },
  emits: ['update:internal-value'],
  data() {
    return {
      iternalPadding: ['', '', '', ''],
      iternalMargin: ['', '', '', ''],
      flexDirectionOptions,
      justifyContentOptions,
      alignItemsOptions,
      flexWrapOptions,
    };
  },
  computed: {
    ...mapGetters('landing', ['landingSettings']),

    fontTypeLabel() {
      return 'Родительский';
    },

    currentScreenSize() {
      const w = this.landingSettings?.size?.width;
      if (!w) return null;
      const item = screenSizes.find(s => s.title === String(w) + 'px');
      return item ? item.title.replace('px', '') : null;
    },

    // безопасный доступ к responsive settings для текущего брейкпоинта
    responsiveSettings() {
      const br = this.currentScreenSize;
      if (!this.internalValue || !this.internalValue.settings) return {};
      const resp = this.internalValue.settings.responsive;
      if (!resp || typeof resp !== 'object') return {};
      return (br && resp[br]) ? resp[br] : {};
    }
  },

  watch: {
    landingSettings: {
      handler() { this.syncSpacing(); },
      deep: true
    },
    internalValue: {
      immediate: true,
      handler() { this.syncSpacing(); }
    },
    currentScreenSize() {
      this.syncSpacing();
    }
  },

  methods: {
    copyId(text) { 
      if (!text) 
        return Promise.resolve(); 
        if (navigator.clipboard && window.isSecureContext) 
          return navigator.clipboard.writeText(text); 
          const ta = document.createElement('textarea'); 
          ta.value = text; 
          ta.style.position = 'fixed'; 
          ta.style.left = '-9999px'; 
          document.body.appendChild(ta); 
          ta.focus(); 
          ta.select(); 
          try { 
            document.execCommand('copy'); 
          } 
          catch(e) {} 
          document.body.removeChild(ta); return Promise.resolve(); 
    },
    emitUpdated(payload) {
      this.$emit('update:internal-value', safeClone(payload));
    },

    deleteElement() {
      const id = this.internalValue?.id;
      if (!id) return;
      if (!window.confirm('Удалить элемент и все его дочерние элементы?')) return;
      this.$store.dispatch('landing/DELETE_ELEMENT', id)
        .then(() => {
          try { this.$store.dispatch('activeElement/UPDATE_ACTIVE_ELEMENT', null); } catch (e) {}
          try { this.$store.dispatch('choosedElement/UPDATE_CHOOSED_ELEMENT', null); } catch (e) {}
          this.emitUpdated(null);
        })
        .catch(err => console.error('deleteElement failed', err));
    },

    copyId(text) {
      if (!text) return Promise.resolve();
      if (navigator.clipboard && window.isSecureContext) return navigator.clipboard.writeText(text);
      const ta = document.createElement('textarea');
      ta.value = text;
      ta.style.position = 'fixed';
      ta.style.left = '-9999px';
      document.body.appendChild(ta);
      ta.focus();
      ta.select();
      try { document.execCommand('copy'); } catch (e) {}
      document.body.removeChild(ta);
      return Promise.resolve();
    },

    // --- spacing sync ---
    syncSpacing() {
      const defaultArr = ['', '', '', ''];
      if (!this.internalValue || !this.internalValue.settings) {
        this.iternalPadding = defaultArr.slice();
        this.iternalMargin = defaultArr.slice();
        return;
      }

      const br = this.currentScreenSize;
      const resp = this.internalValue.settings.responsive;

      const paddingSource = (br && resp && resp[br] && resp[br].padding) ?? this.internalValue.settings.padding;
      const marginSource = (br && resp && resp[br] && resp[br].margin) ?? this.internalValue.settings.margin;

      this.iternalPadding = normalizeSpacingVal(paddingSource);
      this.iternalMargin = normalizeSpacingVal(marginSource);

      while (this.iternalPadding.length < 4) this.iternalPadding.push('');
      while (this.iternalMargin.length < 4) this.iternalMargin.push('');
    },

    buildSpacingString(arr) {
      return buildSpacingString(arr);
    },

    updatePadding(val, indx) {
      const parsed = (val === '' || val === null || val === undefined) ? null : Number(val);
      this.iternalPadding.splice(indx, 1, parsed);
      const paddingString = this.buildSpacingString(this.iternalPadding);
      if (this.currentScreenSize) this.updateResponsiveSetting(this.currentScreenSize, 'padding', paddingString === undefined ? undefined : paddingString);
      else this.updateSetting('padding', paddingString === undefined ? undefined : paddingString);
    },

    updateMargin(val, indx) {
      const parsed = (val === '' || val === null || val === undefined) ? null : Number(val);
      this.iternalMargin.splice(indx, 1, parsed);
      const marginString = this.buildSpacingString(this.iternalMargin);
      if (this.currentScreenSize) this.updateResponsiveSetting(this.currentScreenSize, 'margin', marginString === undefined ? undefined : marginString);
      else this.updateSetting('margin', marginString === undefined ? undefined : marginString);
    },

    // update top-level setting (non-responsive)
    updateSetting(key, value) {
      const newVal = safeClone(this.internalValue || {});
      if (!newVal.settings) newVal.settings = {};
      if (value === null || value === undefined) delete newVal.settings[key];
      else newVal.settings[key] = value;
      this.emitUpdated(newVal);
    },

    // update under responsive breakpoint
    updateResponsiveSetting(breakpointKey, prop, value) {
      const newVal = safeClone(this.internalValue || {});
      if (!newVal.settings) newVal.settings = {};
      if (!newVal.settings.responsive || typeof newVal.settings.responsive !== 'object') newVal.settings.responsive = {};
      if (!newVal.settings.responsive[breakpointKey] || typeof newVal.settings.responsive[breakpointKey] !== 'object') newVal.settings.responsive[breakpointKey] = {};

      const parsedValue = (value === null || value === undefined) ? undefined : value;
      if (parsedValue === undefined) {
        delete newVal.settings.responsive[breakpointKey][prop];
        if (Object.keys(newVal.settings.responsive[breakpointKey]).length === 0) delete newVal.settings.responsive[breakpointKey];
      } else {
        newVal.settings.responsive[breakpointKey][prop] = parsedValue;
      }

      if (newVal.settings.responsive && Object.keys(newVal.settings.responsive).length === 0) delete newVal.settings.responsive;

      this.emitUpdated(newVal);
    },

    // convenience: pick responsive if breakpoint exists, otherwise write top-level
    updateResponsiveOrSetting(prop, value) {
      if (this.currentScreenSize) this.updateResponsiveSetting(this.currentScreenSize, prop, value);
      else this.updateSetting(prop, value);
    },

    defaultResponsive(prop) {
      return this.internalValue?.settings?.[prop] ?? '';
    }
  }
};
</script>


<style scoped>
.setting-section { padding-bottom:0.5rem; margin-top:0.5rem; border-bottom:0.1rem solid var(--grey-0); display:flex; flex-direction:column; gap:0.5rem; }
.setting-row { display:flex; align-items:center; gap:0.5rem; }
.setting-column { display:flex; flex-direction:column; gap:0.5rem; width: 100% }
.setting-section__h { text-align:start; font-weight:bold; }
.setting-delete__children { width: fit-content; }
.modal-choosed__container {
  width: 27rem;
  overflow: hidden;
  border-radius: 0.2rem;
}
.modal-choosed__element {
  overflow: scroll;
  height: 100%;
  width: 100%;
  text-wrap: nowrap;
}
.modal-header__h2 {
  font-size: 1.5rem;
  text-align: left;
}
.modal-footer__p {
  text-align: left;
}
.label-row {
  text-wrap: nowrap;
}
.setting-row__p {
  text-align: left;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.modal-copy__svg {
  width: 1rem;
  height: 1rem;
}
.modal-copy__button {
  padding: 0;
  color: white;
  background-color: transparent;
  border: 0.1rem solid var(--color-0);
  padding: 0.2rem;
}
::v-deep(.setting-row > .multiselect__main > .multiselect > .multiselect__tags) {
  width: auto !important;
  text-wrap: nowrap !important;
  .multiselect__single {
    color: white;
    font-weight: 100;
  }
}
.modal-delete__button {
  padding: 0;
  color: white;
  background-color: transparent;
  border: 0.1rem solid var(--color-0);
  padding: 0.2rem;
}

</style>
